module.exports = __webpack_public_path__ + "static/media/UserSettingsPopUp.1c4ca9a0.png";